var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "form-config-dialog",
          attrs: {
            visible: _vm.dialogVisible,
            title: _vm.dialogTitle,
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form-content",
              attrs: {
                model: _vm.form,
                "label-width": "120px",
                rules: _vm.rules
              }
            },
            [
              _c(
                "el-tabs",
                {
                  model: {
                    value: _vm.activeTab,
                    callback: function($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_FormInfo"),
                        name: "formInfo"
                      }
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_FormName"),
                            prop: "name"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_FormNamePlaceholder"
                              )
                            },
                            model: {
                              value: _vm.form.name,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Branch"),
                            prop: "branchId"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "CargoMsg.Cargo_BranchPlaceholder"
                                ),
                                disabled: !_vm.isCreateMode
                              },
                              model: {
                                value: _vm.form.branchId,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "branchId", $$v)
                                },
                                expression: "form.branchId"
                              }
                            },
                            _vm._l(_vm.officeList, function(item) {
                              return _c("el-option", {
                                key: item.officeId,
                                attrs: {
                                  label: _vm.getOfficeLabel(item),
                                  value: item.officeId
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ApplicationScene"),
                            prop: "applicationScene"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "CargoMsg.Cargo_ApplicationScenePlaceholder"
                                ),
                                disabled: !_vm.isCreateMode
                              },
                              model: {
                                value: _vm.form.applicationScene,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "applicationScene", $$v)
                                },
                                expression: "form.applicationScene"
                              }
                            },
                            _vm._l(_vm.applicationSceneOptions, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_BusinessType"),
                            prop: "businessType"
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: _vm.$t(
                                  "CargoMsg.Cargo_BusinessTypePlaceholder"
                                ),
                                disabled: !_vm.isCreateMode
                              },
                              model: {
                                value: _vm.form.businessType,
                                callback: function($$v) {
                                  _vm.$set(_vm.form, "businessType", $$v)
                                },
                                expression: "form.businessType"
                              }
                            },
                            _vm._l(_vm.businessTypeOptions, function(item) {
                              return _c("el-option", {
                                key: item.value,
                                attrs: { label: item.label, value: item.value }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_Remarks"),
                            prop: "remarks"
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              rows: 5,
                              placeholder: _vm.$t(
                                "CargoMsg.Cargo_RemarksPlaceholder"
                              )
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  !_vm.isCreateMode
                    ? _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_InputOutputConfig"),
                            name: "ioConfig"
                          }
                        },
                        [
                          _c("div", { staticClass: "io-config" }, [
                            _c("div", { staticClass: "config-section" }, [
                              _c("div", { staticClass: "section-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_FormInputConfigDescription"
                                    )
                                  )
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "api-input-group" },
                                [
                                  _c("span", { staticClass: "api-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_FormInputAPI")
                                      )
                                    )
                                  ]),
                                  _c("el-input", {
                                    staticClass: "api-textarea",
                                    attrs: {
                                      type: "textarea",
                                      rows: 4,
                                      placeholder: _vm.$t(
                                        "CargoMsg.Cargo_FormInputAPIPlaceholder"
                                      )
                                    },
                                    model: {
                                      value: _vm.form.inputApi,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "inputApi", $$v)
                                      },
                                      expression: "form.inputApi"
                                    }
                                  })
                                ],
                                1
                              )
                            ]),
                            _c("div", { staticClass: "config-section" }, [
                              _c("div", { staticClass: "section-title" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_FormOutputConfigDescription"
                                    )
                                  )
                                )
                              ]),
                              _c(
                                "div",
                                { staticClass: "api-input-group" },
                                [
                                  _c("span", { staticClass: "api-label" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_FormOutputAPI")
                                      )
                                    )
                                  ]),
                                  _c("el-input", {
                                    staticClass: "api-textarea",
                                    attrs: {
                                      type: "textarea",
                                      rows: 4,
                                      placeholder: _vm.$t(
                                        "CargoMsg.Cargo_FormOutputAPIPlaceholder"
                                      )
                                    },
                                    model: {
                                      value: _vm.form.outputApi,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "outputApi", $$v)
                                      },
                                      expression: "form.outputApi"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleConfirm }
                },
                [_vm._v(_vm._s(_vm.confirmButtonText))]
              ),
              _c("el-button", { on: { click: _vm.handleCancel } }, [
                _vm._v(_vm._s(_vm.$t("common.btn.cancel")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }